import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ButtonPrimary, Spinner } from '../StyledComponent';
import { Context } from '../../services/auth';
import Input from '../Input';
import { ReactComponent as VisibilityOn } from '../../assets/visibility_black_24dp.svg';
import { ReactComponent as VisibilityOffIcon } from '../../assets/visibility_off_black_24dp.svg';
import MessagePopUp from '../MessagePopup';
import './styles.scss';

export const Login = () => {
  const history = useHistory();

  const { handleLogin } = useContext(Context);

  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [stayConnected, setStayConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [wrongLogin, setWrongLogin] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [errorMsgTokenSensedia, setErrorMsgTokenSensedia] = useState(false);

  const iconPassword = isShowPassword ? VisibilityOn : VisibilityOffIcon;

  const typePasswordInput = isShowPassword ? 'text' : 'password';

  const styleStayConnected = {
    color: '#1D3054',
    fontWeight: 900,
  };

  function toggleShowPassword() {
    setIsShowPassword(!isShowPassword);
  }

  function redirectToSindico() {
    history.push('/sindico');
  }

  async function login(event) {
    event.preventDefault();

    setLoading(true);

    await autentica();
  }

  async function autentica() {
    let resultLogin = await handleLogin(user.replaceAll(' ', ''), password, stayConnected);

    if (resultLogin == 'unable_to_generate_sensedia_code') {
      setLoading(false);
      setWrongLogin(true);
      setErrorMsgTokenSensedia(true);
      return;
    } else if (resultLogin == 'NotAuthorizedException') {
      setWrongLogin(true);
      setLoading(false);
      return;
    } else if (resultLogin === false) {
      setWrongLogin(true);
      setErrorMsg(true);
      setLoading(false);
      return;
    } else {
      //caso não encontro e token retorna mensagem de erro
      if (localStorage.getItem('token') === undefined || sessionStorage.getItem('token') === undefined) {
        history.push('/');
        return;
      } else if (!localStorage.getItem('token') && !sessionStorage.getItem('token')) {
        setLoading(false);
        setWrongLogin(true);
        return;
      }
      history.push('/atualizar-perfil');
    }

    //só chegará aqui caso exista o token ou caso não seja undefined
  }

  const handleCheckBoxSubmit = () => {
    setStayConnected(!stayConnected);
  };

  let btnLogin = '';

  btnLogin = (
    <ButtonPrimary
      tema={{ primaryColor: '#1D3054' }}
      fullWidth
      disabled={!user || !password || loading}
      id={'btnAcessar'}
    >
      {loading && <Spinner />}
      {!loading && wrongLogin ? 'Tentar novamente' : 'Acessar'}
    </ButtonPrimary>
  );

  return (
    <form onSubmit={login} className='loginForm centralized-column'>
      <Input
        value={user.replace(/\s/g, '')}
        handleInputChange={(e) => setUser(e.target.value)}
        name={'email'}
        type={'email'}
        labelName={'E-mail'}
        size={'100%'}
        error={wrongLogin}
        id={'inputEmail'}
        marginTop={16}
      />

      <Input
        value={password}
        handleInputChange={(e) => setPassword(e.target.value)}
        labelName={'Senha'}
        type={typePasswordInput}
        size={'100%'}
        error={wrongLogin}
        RightIcon={iconPassword}
        onClickRightIcon={toggleShowPassword}
        id={'inputPassword'}
        errorMessage={'Verifique o email e a senha e tente novamente.'}
        marginTop={16}
      />

      <div className='loginForm__forgotPassword'>
        <Link className='loginForm__forgotPassword__link' to='/esqueceu-senha' id='btnForgotPassword'>
          Esqueceu sua senha?
        </Link>
      </div>

      {btnLogin}

      <div className='loginForm__stay-connected' onClick={handleCheckBoxSubmit}>
        <input defaultChecked={stayConnected} checked={stayConnected} type='checkbox' id='checkBoxStayConnected' />

        {stayConnected && <label style={styleStayConnected}>Me mantenha conectado</label>}
        {!stayConnected && <label style={{ color: '#7f7f7f' }}>Me mantenha conectado</label>}
      </div>

      <div className='primeiro-acesso'>
        <span>Ainda não fez seu primeiro acesso? </span>
        <Link
          to='/primeiro-acesso'
          style={
            (errorMsg || errorMsgTokenSensedia ? { marginTop: '24px' } : { marginTop: '40px' },
            {
              transition: '0.3s',
            })
          }
        >
          Clique aqui e faça
        </Link>
      </div>

      <ButtonPrimary
        tema={{ primaryColor: '#1D3054' }}
        light
        fullWidth
        onClick={redirectToSindico}
        id={'btnAcessarComoSindico'}
      >
        Acessar como Síndico(a)
      </ButtonPrimary>

      {errorMsg && (
        <MessagePopUp
          isError
          title={'Erro de acesso'}
          message={
            <div>
              Seu contrato pode não ter sido atualizado em nosso sistema, entre em contato com a{' '}
              <a
                className='whatsapp'
                href='https://api.whatsapp.com/send?phone=553140200400&text=%20Ol%c3%a1%21%20Gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20os%20apartamentos%20da%20Direcional%20:)&source=&data='
                target='_blank'
                rel='noreferrer'
                style={{ color: '#003DA5' }}
              >
                central de relacionamento
              </a>{' '}
              ou no número (31) 4002-2600.
            </div>
          }
        >
          <ButtonPrimary onClick={() => setErrorMsg(false)} tema={{ primaryColor: '#1D3054' }} fullWidth>
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}

      {errorMsgTokenSensedia && (
        <MessagePopUp
          isError
          title={'Tente novamente'}
          message={<>Não foi possível concluir o seu acesso, tente novamente ou volte mais tarde.</>}
        >
          <ButtonPrimary onClick={() => setErrorMsgTokenSensedia(false)} tema={{ primaryColor: '#1D3054' }} fullWidth>
            FECHAR
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </form>
  );
};
